import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  text: {
    primary: '#F5F5F5',
    secondary: '#CCCCCC',
    disabled: '#CCCCCC88',
  },
  primary: {
    main: '#252422',
  },
  secondary: {
    main: '#dddddd',
  },
  success: {
    main: '#43aa8b',
  },
  warning: {
    main: '#f4a261',
  },
  info: {
    main: '#25557e',
  },
  background: {
    default: '#767676',
    paper: '#767676',
  },
  common: {
    black: '#333333',
    white: '#F5F5F5',
  },
  divider: '#CCCCCC88',
};
